import { render, staticRenderFns } from "./TutorInfoSection.vue?vue&type=template&id=5d5119ac"
import script from "./TutorInfoSection.vue?vue&type=script&lang=js"
export * from "./TutorInfoSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d5119ac')) {
      api.createRecord('5d5119ac', component.options)
    } else {
      api.reload('5d5119ac', component.options)
    }
    module.hot.accept("./TutorInfoSection.vue?vue&type=template&id=5d5119ac", function () {
      api.rerender('5d5119ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/one-part-a/components/TutorInfoSection.vue"
export default component.exports